import { useCoursesStore } from '@/stores/courses'

export const prefetchCoursesOnStartup = (pinia) => {
  try {
    const store = useCoursesStore(pinia)
    const p = store?.prefetchPublicCourses?.()
    if (p && typeof p.catch === 'function') p.catch(() => {})
  } catch (_) {}
}
